var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 796 796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #473080;\n      }\n\n      .c {\n        isolation: isolate;\n      }\n\n      .d {\n        fill: #382b73;\n      }\n\n      .e {\n        fill: #d1d3d4;\n        mix-blend-mode: multiply;\n      }\n\n      .f {\n        fill: #fede3a;\n      }\n\n      .g {\n        fill: #ffc733;\n      }\n\n      .h {\n        fill: #e7ad27;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 398,
    cy: 398,
    r: 398
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 398,
    cy: 398,
    r: 344.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "278.75 461.3 298.25 461.3 263.47 568.03 255.83 568.03 220.78 461.3 240.54 461.3 240.54 435.21 167.54 435.21 167.54 461.3 184.67 461.3 241.6 622.32 253.55 622.32 265.4 622.32 275.31 622.32 277.43 622.32 334.36 461.3 351.75 461.3 351.75 435.21 278.75 435.21 278.75 461.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "367.56 461.3 389.96 461.3 389.96 596.49 367.56 596.49 367.56 622.32 447.15 622.32 447.15 596.49 424.48 596.49 424.48 461.3 447.15 461.3 447.15 435.21 367.56 435.21 367.56 461.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m620.39,528.25c5.19-9.46,8.06-20.79,8.06-32.95,0-26.35-13.18-46.91-33.47-55.34-9.22-3.95-20.29-4.74-31.62-4.74h-89.6v26.09h22.4v135.19h-22.4v25.83h79.58v-25.83h-22.66v-40.58h33.47c10.54,0,20.03-.79,28.72-3.69.72-.25,1.42-.52,2.12-.8.22-.09.44-.19.65-.28.47-.2.95-.4,1.41-.62.25-.11.49-.24.74-.36.43-.21.86-.41,1.28-.63.25-.13.49-.27.74-.4.41-.22.83-.45,1.23-.69.24-.14.47-.28.71-.42.41-.25.81-.5,1.22-.76.22-.14.44-.29.66-.43.41-.28.82-.56,1.23-.85.2-.14.39-.28.58-.42.42-.31.84-.63,1.26-.96.16-.13.33-.26.49-.39.45-.36.89-.73,1.32-1.11.12-.11.24-.21.37-.32.49-.44.98-.88,1.45-1.34.06-.06.12-.11.18-.16,3.87-3.74,7.18-8.14,9.88-13.03,0,0,0,0,0,0h0Zm-41.74-3.7c-5.01,2.37-11.33,3.69-18.97,3.69h-28.99v-65.35h29.25c8.7,0,15.28,1.58,20.29,4.48.49.28.97.59,1.43.9.15.1.29.2.43.3.32.23.64.46.95.7.15.12.31.24.46.36.32.27.64.54.95.83.11.1.22.19.33.3.39.36.76.74,1.12,1.14.16.17.31.35.46.52.21.24.42.49.63.74.17.21.34.42.51.64.17.23.34.46.5.69.17.24.34.47.5.72.12.18.23.37.35.55.34.54.67,1.1.98,1.67.09.17.18.34.27.51.17.34.34.69.51,1.04.07.15.14.3.21.46.58,1.3,1.09,2.67,1.51,4.1,0,.02.01.04.02.06.14.46.26.93.38,1.41.03.1.05.2.07.31.12.48.23.97.32,1.47h0c.53,2.67.81,5.52.81,8.54,0,13.7-5.01,24.24-15.28,29.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m184.67,441.3h-17.13v-26.09h73v26.09h-19.76l35.05,106.73h7.64l34.79-106.73h-19.5v-26.09h73v26.09h-17.39l-56.92,161.01h-35.84l-56.92-161.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m367.56,576.49h22.4v-135.19h-22.4v-26.09h79.58v26.09h-22.66v135.19h22.66v25.83h-79.58v-25.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m473.77,576.49h22.4v-135.19h-22.4v-26.09h89.6c11.33,0,22.4.79,31.62,4.74,20.29,8.43,33.47,28.99,33.47,55.34s-13.7,49.28-35.58,56.92c-8.7,2.9-18.18,3.69-28.72,3.69h-33.47v40.58h22.66v25.83h-79.58v-25.83Zm85.91-68.25c7.64,0,13.97-1.32,18.97-3.69,10.28-5.01,15.28-15.55,15.28-29.25,0-12.91-5.01-22.93-13.7-27.93-5.01-2.9-11.6-4.48-20.29-4.48h-29.25v65.35h28.99Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "511.73 424.65 473.77 415.21 473.77 441.3 496.17 441.3 496.17 576.49 473.77 576.49 473.77 602.32 511.73 592.88 511.73 424.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "407.36 424.65 367.56 415.21 367.56 441.3 389.96 441.3 389.96 576.49 367.56 576.49 367.56 602.32 407.36 592.88 407.36 424.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "334.36 441.3 351.75 441.3 351.75 415.21 329.58 424.65 265.4 602.32 277.43 602.32 334.36 441.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "253.55 602.32 190.38 426.32 167.54 415.21 167.54 441.3 184.67 441.3 241.6 602.32 253.55 602.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 241.6,
    y: 588.52,
    width: 33.71,
    height: 13.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "407.36 424.65 447.15 415.21 367.56 415.21 407.36 424.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "407.36 592.88 447.15 602.32 367.56 602.32 407.36 592.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "511.73 592.88 553.35 602.32 473.77 602.32 511.73 592.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m577.63,527.64h-46.95v8.27h33.47c10.54,0,20.03-.79,28.72-3.69,11.88-4.15,21.34-12.74,27.51-23.97-.15.16-18.95,19.4-42.76,19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m511.73,424.65l18.96,18.23h29.25c8.7,0,15.28,1.58,20.29,4.48,6.67,3.84,11.15,10.63,12.89,19.4,0-.01,0-.03,0-.04-.81-8.58-11.08-42.07-39.4-42.07h-42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "329.58 424.65 278.75 415.21 351.75 415.21 329.58 424.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "190.38 426.32 240.54 415.21 167.54 415.21 190.38 426.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "263.47 548.03 270.38 588.52 248.6 588.52 255.83 548.03 263.47 548.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m562.06,225.13c-8.46,0-15.31,6.85-15.31,15.31,0,2.38.54,4.63,1.51,6.64.22.45.45.88.71,1.3.64,1.05,1.4,2.02,2.27,2.89.35.35.71.68,1.09.99.18.15.37.3.56.44l-34.85,40.13-24.79-94.39c1.22-.26,2.39-.65,3.48-1.18.45-.22.88-.45,1.3-.71,1.05-.64,2.02-1.4,2.89-2.27,1.04-1.04,1.93-2.23,2.64-3.53.15-.28.3-.58.43-.87.91-1.95,1.41-4.13,1.41-6.43,0-8.46-6.85-15.31-15.31-15.31s-15.31,6.85-15.31,15.31c0,2.3.51,4.47,1.41,6.43.14.29.28.59.43.87.71,1.3,1.6,2.49,2.64,3.53.87.87,1.83,1.63,2.89,2.27.19.11.38.22.57.33l-37.86,77.04-44.86-118.99c.42-.16.83-.33,1.24-.53,3.12-1.51,5.66-4.04,7.16-7.16.97-2.01,1.51-4.26,1.51-6.64,0-8.46-6.85-15.31-15.31-15.31s-15.31,6.85-15.31,15.31c0,2.38.54,4.63,1.51,6.64,1.51,3.12,4.04,5.66,7.16,7.16.4.19.82.37,1.24.53l-43.63,115.71-36.25-73.77c.19-.11.38-.21.57-.33,1.05-.64,2.02-1.4,2.89-2.27,1.04-1.04,1.93-2.23,2.64-3.53.15-.28.3-.58.43-.87.91-1.95,1.41-4.13,1.41-6.43,0-8.46-6.85-15.31-15.31-15.31s-15.31,6.85-15.31,15.31c0,2.3.51,4.47,1.41,6.43.14.29.28.59.43.87.71,1.3,1.6,2.49,2.64,3.53.87.87,1.83,1.63,2.89,2.27.42.26.86.49,1.3.71,1.09.53,2.26.93,3.48,1.18l-24.79,94.39-34.85-40.13c.19-.14.38-.29.56-.44.38-.31.74-.64,1.09-.99.87-.87,1.63-1.84,2.27-2.89.26-.42.49-.86.71-1.3.97-2.01,1.51-4.26,1.51-6.64,0-8.46-6.85-15.31-15.31-15.31s-15.31,6.85-15.31,15.31c0,2.38.54,4.63,1.51,6.64.21.45.45.88.71,1.3.64,1.05,1.4,2.02,2.27,2.89.35.35.71.68,1.09.99,2.65,2.18,6.04,3.5,9.74,3.5.25,0,.49,0,.73-.02,6.52,20.05,9.95,40.11,10.3,60.16h-12.96c-3.6,0-6.52,2.92-6.52,6.52,0,.23.01.45.03.67.05.52.17,1.02.34,1.49.08.23.18.46.28.67.2.42.45.82.74,1.19.04.06.09.11.13.17,1.2,1.42,2.99,2.33,4.99,2.33h9.71v47.84h-9.71c-3.6,0-6.52,2.92-6.52,6.52,0,.22.01.45.03.67.05.52.17,1.02.34,1.49.08.23.18.46.28.67.2.42.45.82.74,1.19.04.06.09.11.13.17,1.2,1.42,2.99,2.33,4.99,2.33h333.1c3.37,0,6.15-2.56,6.48-5.85.02-.22.03-.44.03-.67,0-3.6-2.92-6.52-6.52-6.52h-9.71v-47.84h9.71c3.37,0,6.15-2.56,6.48-5.85.02-.22.03-.44.03-.67,0-3.6-2.92-6.52-6.52-6.52h-10.12c.35-20.05,3.79-40.11,10.3-60.16.24.01.49.02.73.02,3.7,0,7.09-1.31,9.74-3.5.38-.31.74-.64,1.09-.99.87-.87,1.63-1.84,2.27-2.89.26-.42.49-.86.71-1.3.97-2.01,1.51-4.26,1.51-6.64,0-8.46-6.85-15.31-15.31-15.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 237.75,
    y: 308.36,
    width: 313.69,
    height: 60.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 282.26,
    y: 308.36,
    width: 224.66,
    height: 60.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "394.59 126.55 323.59 314.88 465.6 314.88 394.59 126.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "394.59 126.55 354.65 314.88 434.53 314.88 394.59 126.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 394.59,
    cy: 126.55,
    r: 15.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m394.59,135.62c-7.39,0-13.55-5.23-14.99-12.19-.21,1.01-.32,2.05-.32,3.12,0,8.46,6.85,15.31,15.31,15.31s15.31-6.85,15.31-15.31c0-1.07-.11-2.11-.32-3.12-1.44,6.96-7.6,12.19-14.99,12.19Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m221.96,218.85c14.13,32.01,20.41,64.02,18.84,96.03h64.54l-83.38-96.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "302.72 169.4 264.51 314.88 374.21 314.88 302.72 169.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "302.72 169.4 291.42 314.88 374.21 314.88 302.72 169.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m221.96,218.85c16.28,34.26,37.42,96.03,37.42,96.03h45.96l-83.38-96.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 301.94,
    cy: 169.4,
    r: 15.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m301.94,178.47c-7.39,0-13.55-5.23-14.99-12.19-.21,1.01-.32,2.05-.32,3.12,0,8.46,6.85,15.31,15.31,15.31s15.31-6.85,15.31-15.31c0-1.07-.11-2.11-.32-3.12-1.44,6.96-7.6,12.19-14.99,12.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 229.97,
    cy: 226.39,
    r: 15.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m229.97,235.46c-7.39,0-13.55-5.23-14.99-12.19-.21,1.01-.32,2.05-.32,3.12,0,8.46,6.85,15.31,15.31,15.31s15.31-6.85,15.31-15.31c0-1.07-.11-2.11-.32-3.12-1.44,6.96-7.6,12.19-14.99,12.19Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m570.07,218.85c-14.13,32.01-20.41,64.02-18.84,96.03h-64.54l83.38-96.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "489.31 169.4 527.52 314.88 417.82 314.88 489.31 169.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "489.31 169.4 500.62 314.88 417.82 314.88 489.31 169.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m570.07,218.85c-16.28,34.26-37.42,96.03-37.42,96.03h-45.96l83.38-96.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 490.09,
    cy: 169.4,
    r: 15.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m490.09,178.47c7.39,0,13.55-5.23,14.99-12.19.21,1.01.32,2.05.32,3.12,0,8.46-6.85,15.31-15.31,15.31s-15.31-6.85-15.31-15.31c0-1.07.11-2.11.32-3.12,1.44,6.96,7.6,12.19,14.99,12.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 562.06,
    cy: 226.39,
    r: 15.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m562.06,235.46c7.39,0,13.55-5.23,14.99-12.19.21,1.01.32,2.05.32,3.12,0,8.46-6.85,15.31-15.31,15.31s-15.31-6.85-15.31-15.31c0-1.07.11-2.11.32-3.12,1.44,6.96,7.6,12.19,14.99,12.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m561.14,314.88H228.04c-3.6,0-6.52-2.92-6.52-6.52h0c0-3.6,2.92-6.52,6.52-6.52h333.1c3.6,0,6.52,2.92,6.52,6.52h0c0,3.6-2.92,6.52-6.52,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m228.04,314.88h333.1c3.6,0,6.52-2.92,6.52-6.52H221.52c0,3.6,2.92,6.52,6.52,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m561.14,375.76H228.04c-3.6,0-6.52-2.92-6.52-6.52h0c0-3.6,2.92-6.52,6.52-6.52h333.1c3.6,0,6.52,2.92,6.52,6.52h0c0,3.6-2.92,6.52-6.52,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m228.04,375.76h333.1c3.6,0,6.52-2.92,6.52-6.52H221.52c0,3.6,2.92,6.52,6.52,6.52Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 237.75,
    y: 314.88,
    width: 313.69,
    height: 6
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/VIP.a136b85527c61ed256981f66eba86185.svg";
export { ForwardRef as ReactComponent };